import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as methods from "../../../../../constants/methods";
import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as rccActions from "../../../../../actions/rccActions";
import * as validationHelper from "../../../../../helpers/validationHelper";

import imgLoader from "../../../../../resources/img/loader.svg";

class AdditionalPrintModal extends Component {
    constructor(props) {
        super(props);

        let defaultTemplate = validationHelper.getValidItem(props.templateList, props.defaultTemplate);

        this.state = {
            numberOfCopies: 1,
            template: defaultTemplate,
            templateIndex: this.getTemplateIndex(props.templateList, defaultTemplate)
        };
    }

    getTemplateIndex = (templateList, activeTemplate) => {
        let index = 0;

        for (let template of templateList) {
            if (template.name === activeTemplate) {
                return index;
            }

            index++;
        }

        return 0;
    };

    getTemplateByIndex = (templateList, activeIndex) => {
        let index = 0;

        for (let template of templateList) {
            if (index === activeIndex) {
                return template.name;
            }

            index++;
        }

        return null;
    };

    componentDidMount = () => {
        if (this.props.activeOrder !== null && this.props.printData !== null) {
            this.props.dispatchGetPrintPreviewImageAction(
                this.state.template,
                this.props.activeOrder.formula,
                this.props.printData,
                this.props.activeOrder.formulaMoreInfo,
                this.props.activeOrder.note
            );
        }
    };

    handleMinusButtonClick = () => {
        if (this.state.numberOfCopies > 1) {
            this.setState({numberOfCopies: this.state.numberOfCopies - 1});
        }
    };

    handlePlusButtonClick = () => {
        this.setState({numberOfCopies: this.state.numberOfCopies + 1});
    };

    handleLeftArrowClick = () => {
        if (this.state.templateIndex > 0) {
            let template = this.getTemplateByIndex(this.props.templateList, this.state.templateIndex - 1);

            this.setState({
                template: template,
                templateIndex: this.state.templateIndex - 1
            });

            this.props.dispatchGetPrintPreviewImageAction(
                template,
                this.props.activeOrder.formula,
                this.props.printData,
                this.props.activeOrder.formulaMoreInfo,
                this.props.activeOrder.note
            );
        }
    };

    handleRightArrowClick = () => {
        if (this.state.templateIndex < this.props.templateList.length - 1) {
            let template = this.getTemplateByIndex(this.props.templateList, this.state.templateIndex + 1);

            this.setState({
                template: template,
                templateIndex: this.state.templateIndex + 1
            });

            this.props.dispatchGetPrintPreviewImageAction(
                template,
                this.props.activeOrder.formula,
                this.props.printData,
                this.props.activeOrder.formulaMoreInfo,
                this.props.activeOrder.note
            );
        }
    };

    handleCancelButtonClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handlePrintButtonClick = () => {
        this.props.dispatchStartPrintReportSilentAction(
            this.state.template,
            this.state.numberOfCopies,
            this.props.activeOrder.formula,
            this.props.printData,
            this.props.activeOrder.formulaMoreInfo,
            this.props.activeOrder.note
        );
    };

    getLeftArrow = () => {
        if (this.props.loading || this.state.templateIndex === 0) {
            return <span className="glyphicon glyphicon-menu-left disabled"></span>;
        }

        return <span className="glyphicon glyphicon-menu-left" onClick={this.handleLeftArrowClick}></span>;
    };

    getRightArrow = () => {
        if (this.props.loading || this.state.templateIndex >= this.props.templateList.length - 1) {
            return <span className="glyphicon glyphicon-menu-right disabled"></span>;
        }

        return <span className="glyphicon glyphicon-menu-right" onClick={this.handleRightArrowClick}></span>;
    };

    getPrinterImage = () => {
        if (this.props.templateList.length === 0) {
            return <Translate value="print.noTemplatesAvailable" />;
        }

        if (this.props.loading) {
            return <img alt="canister" src={imgLoader} className="printer-preview" />;
        }

        let printImage = window.imageStore.getPrintImageByName(this.state.template);

        if (printImage === null) {
            return <img alt="canister" src={imgLoader} className="printer-preview" />;
        }

        return <img alt="preview" src={"data:" + printImage.type + ";base64," + printImage.img} />;
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-medium-modal">
                <div className="modal-content">
                    <div className="col-xs-12 text-left">
                        <Translate value="print.numberOfCopies" />
                    </div>
                    <div className="col-xs-12 number-of-copies">
                        <button className="btn btn-danger btn-additional-print" onClick={this.handleMinusButtonClick}>
                            -
                        </button>
                        <input
                            className="another-settings-input"
                            type="number"
                            value={this.state.numberOfCopies}
                            readOnly
                        />
                        <button className="btn btn-danger btn-additional-print" onClick={this.handlePlusButtonClick}>
                            +
                        </button>
                    </div>
                    <div className="col-xs-12 image-preview">
                        {this.getLeftArrow()}
                        {this.getPrinterImage()}
                        {this.getRightArrow()}
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCancelButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handlePrintButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.print" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    return {
        templateList: store.rcc.templateList,
        defaultTemplate: store.settings.printerTemplate,
        activeOrder: store.toDispense.activeOrder,
        printData: store.toDispense.printData,
        imageStore: store.navigation.imageStore,
        loading: store.rcc.expected.some(
            (request) => request.tabId === ownProps.tabId && request.method === methods.PRINTER_EVENT_JPG_EXPORT_DONE
        )
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_ADDITIONAL_PRINT_MODAL));
        },
        dispatchStartPrintReportSilentAction: (template, pages, formula, printData, moreInfoText, note) => {
            dispatch(
                rccActions.startPrintReportSilent(
                    null,
                    template,
                    null,
                    pages,
                    null,
                    formula,
                    printData,
                    moreInfoText,
                    note
                )
            );
        },
        dispatchGetPrintPreviewImageAction: (template, formula, printData, moreInfoText, dispenseNote) => {
            dispatch(
                rccActions.getPrintPreviewImage(null, template, null, formula, printData, moreInfoText, dispenseNote)
            );
        }
    };
};

export default AdditionalPrintModal = connect(mapStoreToProps, mapDispatchToProps)(AdditionalPrintModal);
